import { useRouter } from "next/router";
import { memo, useState } from "react";

import Modal from "~/components/ui/modal";
import { useAuth } from "~/contexts/providers/auth";
import { useLanguage } from "~/contexts/providers/language";
import { UserType } from "~/types/auth/userEnums.types";
import { SubscriptionStatus } from "~/types/subscription/subscription.types";

import styles from "./index.module.scss";

const SubscriptionSuggestionPopup = () => {
  const { user } = useAuth();
  const { language } = useLanguage();
  const router = useRouter();

  const [modalOpen, setModalOpen] = useState<boolean>(true);

  // if user is not preselected and doesn't have a subscription and month is not december return null
  if (
    !(
      user &&
      user.type === UserType.PRE_SELECTED &&
      (!user.subscription ||
        user.subscription.subscriptionStatus === SubscriptionStatus.PENDING) &&
      new Date().getMonth() === 11
    )
  )
    return null;

  const handleSetModalClose = () => {
    setModalOpen(false);
  };

  const reduced = user.subscriptionType === "REDUCED_MEMBER";
  const special = user.subscriptionType === "SPECIAL";

  const handleClick = () => {
    router.push("/account?tab=Membership");
  };

  const { tab } = router.query;

  return (
    <Modal open={tab ? false : modalOpen} onClose={handleSetModalClose}>
      <div className={styles.container}>
        <p>
          {language === "En" ? "Hello" : "Bonjour"} {user.firstname} <br />
          <br />
          {language === "En" ? (
            <p className={styles.indent}>
              Our special anniversary offer expires soon. You only have one
              month left to enjoy our program for free. <br /> <br />
              The good news? Until December 31st, you can renew your Silencio
              subscription at a special rate. <br />
              <br />
              Activate your subscription for{" "}
              {reduced ? 600 : special ? 900 : 1200}€ / year (or{" "}
              {reduced ? 50 : special ? 75 : 100}€/month)
            </p>
          ) : (
            <p className={styles.indent}>
              Notre offre spéciale anniversaire expire bientôt. Il ne vous reste
              plus qu’un mois pour profiter de notre programmation gratuitement.{" "}
              <br /> <br />
              La bonne nouvelle ? Jusqu’au 31 décembre, vous bénéficiez d’un
              tarif ami pour le renouvellement de votre abonnement Silencio.{" "}
              <br /> <br />
              Activez votre abonnement {reduced ? 600 : special ? 900 : 1200}€ /
              an (soit {reduced ? 50 : special ? 75 : 100}€/mois)
            </p>
          )}
          <div className={styles.activateButton}>
            <button onClick={handleClick}>
              {language === "En" ? "Subscribe" : "S'abonner"}
            </button>
          </div>
        </p>
      </div>
    </Modal>
  );
};

export default memo(SubscriptionSuggestionPopup);
